import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { getParams, GlobalEnvironment } from 'Helpers';
import { PartMaster } from "Models";
import { StatusCodeService } from 'Services';
import { msalTemp } from 'Contexts/AuthProvider';

export class PartMasterService {

    static GetPartMasterStartingWith(id: string): Observable<PartMaster[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/PartMaster/${id}`, params).pipe(
            switchMap(response => {
                if (response.ok) { // use http
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "GetRequest"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }

    static GetByPartNumber(partNumber: string): Observable<PartMaster> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/PartMaster/partNumber/${partNumber}`, params).pipe(
            switchMap(response => {
                if (response.ok) { // use http
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "PartMasterService.GetByPartNumber"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static GetAll(): Observable<PartMaster[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/PartMaster/getAll`, params).pipe(
            switchMap(response => {
                if (response.ok) { // use http
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "PartMasterService.GetAll"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}